import { isRejectedWithValue } from "@reduxjs/toolkit";
import { ERROR_STATUS_CODE_MAP } from "../../config/errors.js";
import { isErrorStatusCode } from "../utils/isErrorStatusCode.js";
const rtkQueryErrorLoggerMiddleware = (_api) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const { payload: error } = action;
    if (isErrorStatusCode(error.statusCode)) {
      console.error(
        "%c Трейд-ин калькулятор АВН.",
        "color: white; background-color: #D33F49",
        ERROR_STATUS_CODE_MAP[error.statusCode],
        error.meta
      );
    } else {
      console.error("%c Трейд-ин калькулятор АВН. ", "color: white; background-color: #D33F49", error);
    }
  }
  return next(action);
};
export {
  rtkQueryErrorLoggerMiddleware
};
